import React from 'react'
import styles from './CardInfo.module.scss'
import SectionTitle from '../../../../components/SectionTitle/SectionTitle'
import { Link } from 'react-router-dom'
import ArrowIcon from '../../../../img/IconComponents/ArrowIcon';


const CardInfo = ({ title, value, dimension, image, action = null }) => {

  return (
    <div className={styles.card}>
      <div>
        <SectionTitle text={title} />
        <div className={styles.card__value}>
          {localStorage.getItem('i18n') !== 'DE' ? value : value.toString().replace('.', ',')}
          <span>{dimension}</span>
        </div>
        {
          action !== null ? 
          <Link to={action?.path} state={{from:window.location.pathname}} className={styles.card__link}>
            <div>{action?.text}</div>
            <ArrowIcon />
          </Link>
          :
          null
        }
      </div>
      <picture>
        <source srcSet={image} type="image/webp" />
        <img src={image} alt="dashboard-icon" />
      </picture>

    </div>
  )
}

export default CardInfo;